import { render } from "./BehaviorCharacteristics.vue?vue&type=template&id=2939f8be"
import script from "./BehaviorCharacteristics.vue?vue&type=script&lang=js"
export * from "./BehaviorCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script